import { Icon } from '@iconify/react/dist/iconify.js';
import { Circle } from 'react-feather';

export default [
    {
        id: 'project-setup',
        title: 'Project Setup',
        icon: <Circle size={20} />,
        children: [
            {
                id: 'road-type',
                title: 'Road Type',
                icon: <Circle size={20} />,
                navLink: '/project-setup/road-type'
            },
            {
                id: 'project-owner',
                title: 'Project Owner',
                icon: <Icon icon="wpf:administrator" height={20} width={20} />,
                navLink: '/project-setup/project-owner'
            },
            {
                id: 'agency-contractor',
                title: 'Agency/Contractor',
                icon: <Icon icon="map:insurance-agency" />,
                navLink: '/project-setup/agency'
            }
        ]
    }
];
